// extracted by mini-css-extract-plugin
export var table = "_ve-0";